import React from 'react';

/**
 * Section — white card wrapper for each form section.
 * @param {string} title   - Section heading displayed at top
 * @param {node}   children
 */
function Section({ title, children }) {
  return (
    <div className="section-card">
      {title && <h2 className="section-title">{title}</h2>}
      {children}
    </div>
  );
}

export default Section;
